export const LOADING = 'Loading...';
export const NORECORDS = 'Records not found.';
export const VEHICLE_NOT_FOUND = 'Vehicle not found.';
export const NODATAFOUND = 'No Data Found.';
export const NOPERMISSION = 'You do not have the required permissions to perform this action.';
export const NOPHOTO = 'No photos';
export const NODATA = 'No Data.';
export const DOWNLOADXLS = 'Download xls';
export const ALL_VIDEO_EXTENSIONS = 'mp4, mkv, flv, avi, mts, wmv, mov';
export const ALL_AUDIO_EXTENSIONS = 'mp3, wav, aac, oga, opus, weba, 3gp, 3g2';
export const ALL_IMAGE_EXTENSIONS = 'jpg ,jpeg ,jpe ,png ,gif ,bmp ,tif ,tiff ,webp ,svg';
export const ALL_TEXT_EXTENSIONS = 'txt, xml, css, csv, htm, html, ics, js, mjs';
export const ALL_FONT_EXTENSIONS = 'otf, ttf';
export const ASCENDING = 'asc';
export const DESCENDING = 'desc';
export const IMAGE_FILE_TYPE = 'image';
export const PDF_FILE_TYPE = 'pdf';

export const DEALERSHIP = 'dealership';
export const PHOTOGRAPHER = 'photographer';
export const TEAM = 'team';
export const GROUP = 'group';
export const MAVIS = 'mavis';
export const EDITTRACKER = 'edittracker';
export const SALES = 'sales';
export const VIDEO = 'video';
export const IMAGE = 'image';
export const EXPORT = 'export';
export const INSTA360 = 'insta360';
export const EXT360 = 'ext360';
export const IMPORT = 'import';

export const SINGLE_QUOTE = "'"; //'&apos;'

export const OPEN_SIDEBAR = 'open';
export const CLOSE_SIDEBAR = 'close';
export const EDCHART_VAL = 'edchart';
export const PACHART_VAL = 'pachart';

export const REGISTERED_TRADEMARK_SYMBOL = '®';
export const TM_TRADEMARK_SYMBOL = '™'; // &trade;

export const DEFAULT_TEMP_TAGS = '[MAKE] [YEAR] [MODEL]';

export const PA_ROLE = 'pa';
export const DD_ROLE = 'dd';
export const EDITING_QUEUE = 'EQ';
export const QC_QUEUE = 'QCQ';
export const AUTO_PUBLISH_QC_QUEUE = 'APQCQ';
export const AUTO_PUBLISH_QUEUE = 'APQ';

export const TREE_VIEW = 'tree';
export const TABLE_VIEW = 'table';
export const MAVISTABLE = 'mavistable';

export const WINDOW_STICKER_BANNER =
  'Billing Update: Starting June 1, invoices for window sticker orders will be generated when the order is processed.';
